import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRouter } from 'next/router';
import { AgencyFilterHeaderContainer, ChipLink, chipsStyles } from './styled';
import { Chips } from '../../../ui/Chips';
import { AGENCY_FILTER_CATEGORY_ALL_ID } from '../../../../utils/constants/agencyPage';
import {
  buildAgencyUrl,
  getAgencyFilterCategoryStatName
} from '../../../../utils/helpers/agencyPage';
import { AgencyFilterHeaderProps } from './types';

export const AgencyFilterHeader: React.FC<AgencyFilterHeaderProps> = ({
  categories,
  onClickItem,
  activeCategoryId,
  categoriesContainerRef,
  isCurrentItemPage
}) => {
  const { t } = useTranslation();
  const router = useRouter();

  const allCategories = [
    {
      id: AGENCY_FILTER_CATEGORY_ALL_ID,
      pluralName: t('pages.agency.all_categories'),
      stat: `${isCurrentItemPage ? 'current-item' : 'agency'}-filter-all`
    },
    ...categories.map(category => ({
      ...category,
      stat: getAgencyFilterCategoryStatName(category.slug, isCurrentItemPage)
    }))
  ];

  return (
    <AgencyFilterHeaderContainer
      data-cy="agency-filter__header"
      ref={categoriesContainerRef}
      $isCurrentItemPage={isCurrentItemPage}
    >
      {allCategories?.map(item => {
        const chip = (
          <Chips
            id={`chip-${item.id}`}
            key={item.id}
            text={item?.pluralName}
            value={item.id}
            type="button"
            hasCustomOnChange
            storedValue={activeCategoryId}
            onClick={isCurrentItemPage ? () => onClickItem(item.id) : undefined}
            styles={chipsStyles}
            cypress="agency-filter__header-item"
            stat={item.stat}
          />
        );

        if (isCurrentItemPage) return chip;

        const href = buildAgencyUrl({
          agencySlug: router.query.agency,
          clickedId: item.id,
          activeLeasedCategory: [],
          categories
        });

        return (
          <ChipLink
            key={item.id}
            href={href}
            locale={false}
            scroll={false}
            shallow
            onClick={e => {
              e.preventDefault();
              onClickItem(item.id);
            }}
          >
            {chip}
          </ChipLink>
        );
      })}
    </AgencyFilterHeaderContainer>
  );
};
